

















import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import MultiSelectBroadcaster from "@/models/MultiSelectBroadcaster";

@Component({})
export default class MultiSelectCheckbox extends Vue {
  @Prop({ required: true }) readonly value!: boolean | MultiSelectBroadcaster;
  @Prop({ required: false }) readonly label?: string;
  @Prop() readonly inputValue?: MultiSelectBroadcaster;
  @Prop({ default: false }) readonly disabled!: boolean;

  selected = this.value;

  get id() {
    return "checkbox-" + this.randomValue();
  }

  get checkboxValue() {
    return this.inputValue ? this.inputValue : this.label;
  }

  @Watch("value", { immediate: true })
  onValueUpdated(value: MultiSelectBroadcaster) {
    this.selected = value;
  }

  randomValue() {
    return Math.random().toString(36).substr(2, 9);
  }

  onChange(value: MultiSelectBroadcaster) {
    this.$emit("input", this.selected);
  }
}
